<template>
  <div id="quick-quote-app">
    <div v-show="isLoading" id="overlay" />
    <div v-show="isLoading" id="loader" />

    <div class="row">
      <div class="small-12 medium-6 columns">
        <h1>
          Titanium Industries | Quick Quote
          <a href="#" @click="$refs.faqModal.open()"
            >Frequently Asked Questions</a
          >
        </h1>
      </div>
    </div>

    <vue-modality
      ref="faqModal"
      title="Frequently Asked Questions"
      centered
      :hide-cancel="true"
      :hide-ok="true"
      width="800px"
      @ok="$refs.faqModal.hide()"
      @cancel="$refs.faqModal.hide()"
    >
      <h5>Where am I?</h5>
      <p>You've reached Titanium Industries new Quick Quote application.</p>
      <h5>What happened to the product I selected?</h5>
      <p>
        Your selection will appear below and is also located in "Your Quote",
        located in the upper right corner.
      </p>
      <h5>Can I continue to build my quote/order here?</h5>
      <p>
        Yes! Please select products from the drop downs and click "Add to Quote"
        and your selection will appear below.
      </p>
      <h5>Can I custom cut products?</h5>
      <p>
        Most products offered at T.I. allow for custom cuts. Some products may
        not have this ability through our online store, but are available upon
        request.
      </p>
      <h5>
        What if a product I am looking for is not present in the drop downs?
      </h5>
      <p>
        Some products offered at T.I. are not currently listed online, please
        reach out to us at sales@titanium.com, call us +1 888.482.6486, or
        complete our <a href="https://titanium.com/rfq">RFQ Submittal form</a>.
      </p>
      <h5>How do I request certifications or other documents?</h5>
      <p>
        Certifications and supporting documents are available upon request.
        Please list the items you require in the "Comments" section located
        below.
      </p>
      <h5>How do I access previous orders I placed on the online store?</h5>
      <p>
        Documents can be located in your account. Please click "My Account"
        located at the top of your screen.
      </p>
      <h5>Is the shop connected to my current account I have with T.I.?</h5>
      <p>
        Presently, purchases made offline and supporting documents are not
        available through T.I.'s online shop. All previous orders made through
        the online shop can be found in "My Account", located above.
      </p>
      <h5>When do I select shipping method?</h5>
      <p>The following screen will provide shipping methods.</p>
      <h5>When do I pay?</h5>
      <p>
        Payment options are available on the following screen. Credit Card and
        Pay by Invoice are currently options for payment.
      </p>
    </vue-modality>

    <div class="row" style="margin-bottom: 20px">
      <div class="small-12 medium-6 columns">
        <h1>Welcome to the Titanium Industries Quick Quote Application</h1>
        <p>If you were directed here from our specialty metals product
          page your selection will appear below. Please continue to build your
          metal materials quote on this screen.</p>
        <a
          type="button"
          class="button blue rounded"
          style="padding: 0; text-decoration: none;"
          href="/shop/discounted_products"
        >
          Discounted Products
        </a>
        <h3 v-if="!authenticated" style="color: red;"><strong><a href="/shop/login" style="color: red;">Sign in / Approval</a> Required to Access Quick Quote Tool</strong></h3>
        <h3 v-if="!activeShop" style="color: red;"><strong>Shop Temporarily Closed. Please check back later.</strong></h3>
      </div>
      <div class="small-12 medium-6 columns"></div>
    </div>

    <quote-creation-tool
      :authenticated="authenticated"
      :activeShop="activeShop"
      :perform-reset-form="performResetForm"
      @add-item="addItem"
      @add-custom-item="addCustomItem"
      @form-is-reset="performResetForm = false"
    />

    <materials-list
      style="margin-bottom: 50px"
      :cart-data="cartData"
      @delete-line-item="deleteLineItem"
      @update-quantity="updateQuantity"
    />
  </div>
</template>

<script>
import MaterialsList from "components/QuickQuote/TheMaterialsList";
import QuoteCreationTool from "components/QuickQuote/TheQuoteCreationTool";
import { mapMutations, mapState } from "vuex";
import VueModality from "vue-modality";

export default {
  components: {
    MaterialsList,
    QuoteCreationTool,
    VueModality
  },
  data: function() {
    return {
      authenticated: true,
      activeShop: true,
      cartData: {},
      performResetForm: false,
      timer: 0
    };
  },
  computed: mapState(["isLoading"]),
  mounted() {
    this.retrieveOrder();
  },
  methods: {
    ...mapMutations(["setLoading"]),
    addItem(newItem) {
      this.setLoading(true);

      this.$axios
        .post("/shop/orders/populate_quick_quote.json", {
          variants: [
            {
              variant_id: newItem.variant.id,
              quantity: newItem.quantity,
              uom: newItem.uom
            }
          ]
        })
        .then(response => {
          this.performResetForm = true;
          this.cartData = response.data;
        })
        .catch(error => {
          if (error.response.status === 422) {
            if (
              error.response.data.errors[0].detail ===
              "Please enter a reasonable quantity."
            ) {
              alert(
                "Your selection exceeds maximum quantities available through our website. Please contact us today: email us at sales@titanium.com or call +1 973.983.1185"
              );
            } else {
              alert(
                "All on hand material has been reserved. Please call to discuss options to fulfill your requirements. Please contact us today: email us at sales@titanium.com or call +1 973.983.1185"
              );
            }
          } else {
            alert(
              "An error occurred when adding this selection to your quote."
            );
          }
        })
        .then(() => {
          this.setLoading(false);
        });
    },
    addCustomItem(newItem) {
      this.setLoading(true);

      // Bug fix 221, remove 0 width from variant so price calculations work
      var set_width = null;
      if (newItem.size.width != 0) {
        set_width = newItem.size.width;
      }

      this.$axios
        .post("/shop/variant_customs/create_for_quick_quote.json", {
          variant_id: newItem.variant.id,
          quantity: newItem.quantity,
          variant_custom: {
            depth: newItem.size.depth,
            width: set_width
          }
        })
        .then(response => {
          this.performResetForm = true;
          this.cartData = response.data;
        })
        .catch(error => {
          if (error.response.status === 422) {
            alert(error.response.data.errors[0].detail);
          } else {
            alert(
              "An error occurred when adding this selection to your quote."
            );
          }
        })
        .then(() => {
          this.setLoading(false);
        });
    },
    deleteLineItem(id) {
      this.setLoading(true);

      this.$axios.delete(`/shop/orders/line_item/${id}`).then(response => {
        this.cartData = response.data;
        this.setLoading(false);
      });
    },
    retrieveOrder() {
      this.setLoading(true);

      this.$axios
        .get("/shop/quick_quote/serialize_order.json")
        .then(response => {
          this.cartData = response.data;
          this.setLoading(false);
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.authenticated = false;
          } else if (error.response.status === 406) {
            this.activeShop = false;
          }
        })
        .then(() => {
          this.setLoading(false);
        });
    },
    updateQuantity(id, quantity) {
      // debounce this method to prevent multiple calls when
      // muli-digit quantities are typed
      clearTimeout(this.timer);

      this.timer = setTimeout(
        function() {
          this.setLoading(true);

          this.$axios
            .patch(`/shop/orders/line_item/${id}`, {
              quantity: quantity
            })
            .then(response => {
              this.cartData = response.data;
            })
            .catch(error => {
              if (error.response.status === 422) {
                if (
                  error.response.data.errors[0].detail ===
                  "Quantity Please enter a reasonable quantity."
                ) {
                  alert(
                    "Your selection exceeds maximum quantities available through our website. Please contact us today: email us at sales@titanium.com or call +1 973.983.1185"
                  );
                } else {
                  alert(
                    "All on hand material has been reserved. Please call to discuss options to fulfill your requirements. Please contact us today: email us at sales@titanium.com or call +1 973.983.1185"
                  );
                }
              } else {
                alert("An error occurred when updating this line item.");
              }
            })
            .then(() => {
              this.setLoading(false);
            });
        }.bind(this),
        1000
      );
    }
  }
};
</script>

<style lang="scss">
#quick-quote {
  button {
    margin: 0;
  }

  h5 {
    font-size: 1rem;
    text-transform: none;
  }

  tbody td {
    border: 1px solid black;
    padding: 5px;
  }

  thead th {
    text-align: left;
    padding: 5px;
  }

  .callout {
    border: 1px solid black;
    padding: 10px;
    margin-bottom: 15px;
  }

  .inline {
    display: inline-block;
  }

  .orange {
    background-color: #ffa834;
    color: black;
    text-transform: none;
  }

  .gray {
    background-color: #757575;
    color: white;
    line-height: inherit;
    min-width: 155px;
    text-transform: none;

    &.green {
      background-color: #0a0;
    }
  }

  .rounded {
    border-radius: 5px;
  }

  .float-right {
    float: right;
  }

  .no-border {
    border: none;
  }

  a {
    font-weight: bold;
    text-decoration: underline;
  }

  h1 a {
    font-size: 16px;
    text-transform: none;
  }

  #overlay {
    position: fixed;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 2;
  }

  #loader {
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 3;
    width: 120px;
    height: 120px;
    margin: -76px 0 0 -76px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid rgb(3, 42, 104);
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
